import { useUser } from "@js/apps/common/hooks/use-user";

export const useIsEmployerImpersonated = () => {
  const user = useUser();
  return !!user?.employer && user?.is_impersonated_session;
};
